
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import { toast } from 'react-toastify';
import { dataUser } from './..//Helpers/util';
import axiosInstance from '../../utils/axiosInstance';

const apiURL = require('./../../constant');
const URL_API = apiURL.PROD_URL;
const userDataLocal = dataUser();
var UserObj = JSON.parse(userDataLocal);

function ParkingViewNew({ rowDatas, article, changeListStatus }) {
    const [tagId, setTagId] = useState('');
    const [secretCode, setSecretCode] = useState('');
    const [ParkingCount, setParkingCount] = useState([]);
    const [selectedOption, setSelectedOption] = useState('1')

    const changeTagId = (event) => {
        setTagId(event.target.value)
    }

    const changeSecretCode = (event) => {
        setSecretCode(event.target.value)
    }

    const handleOptionChange = (event) => {
        setSelectedOption(event.target.value)
    };

    const assignTagIdAndSecretCode = async () => {
        let authToken = JSON.parse(localStorage.getItem('headData'));
      
        try {
          const dataAry = {
            rec_id: rowDatas?.rec_id,
            tag_id: tagId,
            secret_code_id: secretCode,
            vehicle_number: rowDatas?.vehicle_number,
            user_id: rowDatas?.user_id,
            phone: rowDatas?.phone,
            wheeler: rowDatas?.wheeler,
            user_name: rowDatas?.user_name,
            spoc_name: `${UserObj?.fname} ${UserObj?.lname}`,
            spoc_email: UserObj?.email,
            user_email: rowDatas?.email,
          };
      
          // First POST request for parkplus_assign
          const response = await axiosInstance.post(`${process.env.REACT_APP_API_GATEWAYS_URL}cspoc/api/v1/parking/parkplus_assign`, dataAry, {
           
          });
      
          // Handle response status
          if (response.data.status === 200) {
            toast.success('Request Approved Successfully', {
              
            });
      
            const articleStatus = article.status;
            article.status = false;
      
            // Second POST request for parkplus_countv2
            const countResponse = await axiosInstance.post(`${process.env.REACT_APP_API_GATEWAYS_URL}cspoc/api/v1/parking/parkplus_countv2`, article, {
              headers: {
                Authorization: authToken?.spintlyToken,
              }
            });
            setParkingCount(countResponse.data.data);
      
            changeListStatus(articleStatus);
          } else {
            toast.error(response.data.message, {
              
            });
          }
        } catch (error) {
          console.error('Error during the API calls:', error);
        }
      };


    return (
        <>
            <div className="modal-dialog custome">
                <div className="modal-content custome">
                    <div className="formTitle">
                        Request Details
                        <button
                            type="button"
                            className="relateDox close"
                            id="modalCancel"
                            data-dismiss="modal"
                        >
                            x
                        </button>
                    </div>
                    <div className="modal-body custome">
                        <div className="addmemberformBody">
                            <form>

                                <div className="row py-2">
                                    <div className="col-md-6 ">
                                        <div className="visiContent px-0 py-1 mt-0">
                                            <p className="downPara">User Name</p>
                                            <p>
                                                {rowDatas?.user_name}
                                            </p>
                                        </div>
                                    </div>
                                    <div className="col-md-6 ">
                                        <div className="visiContent px-0 py-1 mt-0">
                                            <p className="downPara">Email</p>
                                            <p>

                                                {rowDatas?.email}
                                            </p>
                                        </div>
                                    </div>
                                    <div className="col-md-6 ">
                                        <div className="visiContent px-0 py-1 mt-0">
                                            <p className="downPara">Mobile No.</p>
                                            <p>

                                                {rowDatas?.phone}
                                            </p>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="visiContent px-0  py-1 mt-0">
                                            <p className="downPara">Location Name</p>
                                            <p>
                                                {rowDatas?.location_name}
                                            </p>
                                        </div>
                                    </div>
                                    <div className="col-md-6 ">
                                        <div className="visiContent px-0  py-1 mt-0">
                                            <p className="downPara">Vehicle Type</p>
                                            <p>{rowDatas?.wheeler} Wheeler</p>
                                        </div>
                                    </div>
                                    <div className="col-md-6 ">
                                        <div className="visiContent px-0  py-1 mt-0">
                                            <p className="downPara">Vehicle Number</p>
                                            <p>
                                                {rowDatas?.vehicle_number}
                                            </p>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="visiContent px-0  py-1 mt-0">
                                            <p className="downPara">Vehicle RC</p>
                                            <p> <a
                                                href={rowDatas?.vehicle_rc}
                                                target="_blank"
                                                class="text-primary"
                                            >
                                                View
                                            </a></p>
                                        </div>
                                    </div>
                                </div>
                                <div className="row mt-4">
                                    {rowDatas?.wheeler === "4" ?
                                        <div className="col-md-12">
                                            <div className='d-flex justify-content-between'>
                                                <div>Select Tag type for vehicle entry</div>
                                                <div>
                                                    <div class="TagType-Switch">
                                                        <input type="radio" id="RFID-Tag" name="Tag-switch" value="1" checked={selectedOption === '1'}
                                                            onChange={handleOptionChange} />
                                                        <label for="RFID-Tag">RFID Tag</label>
                                                        <input type="radio" id="FASTag" name="Tag-switch" value="2" checked={selectedOption === '2'}
                                                            onChange={handleOptionChange} />
                                                        <label for="FASTag">FASTag</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div> : ""}
                                    {selectedOption === '1' ?
                                        <><div className="col-md-12 col-xl-12 col-lg-12">
                                            <div className="formAddmemGrid">
                                                <label>Tag ID</label>
                                                <span className="text-danger1">
                                                    *
                                                </span>
                                                <input
                                                    type="text"
                                                    name="tagId"
                                                    value={tagId}
                                                    onChange={changeTagId}
                                                    className="form-control" />
                                            </div>
                                        </div><div className="col-md-12 col-xl-12 col-lg-12">
                                                <div className="formAddmemGrid">
                                                    <label>Secret Code </label>
                                                    <span className="text-danger1">
                                                        *
                                                    </span>
                                                    <input
                                                        type="text"
                                                        name="secretCode"
                                                        value={secretCode}
                                                        onChange={changeSecretCode}
                                                        className="form-control" />
                                                </div>
                                            </div></> : ""}
                                </div>
                            </form>
                            <div className="addmemberFooter">
                                <div className="pull-right">
                                    <button
                                        className="btn btn-danger solCancel"
                                        type="button"
                                        data-dismiss="modal"
                                    >
                                        Cancel
                                    </button>

                                    <button
                                        className="btn btn-primary addBtn ml10"
                                        onClick={assignTagIdAndSecretCode}
                                        disabled={!tagId || !secretCode}
                                    >
                                        Assign
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div >
                </div >
            </div>
        </>
    );
}
export default connect(
)(ParkingViewNew);
